<template>
    <div class="bordas botoes-excel">
        <export-excel-leitos :items="listagemMapaLeitos.dados" :unidade="unidadeSelecionada"/>
        <export-excel-consolidado :unidade="unidadeSelecionada"/>
    </div>
</template>

<script>
import ExportExcelLeitos from '../../../shared/export-excel/ExportExcelLeitos.vue'
import ExportExcelConsolidado from '../../../shared/export-excel/ExportExcelConsolidado.vue'

export default {
    components: {
        ExportExcelLeitos,
        ExportExcelConsolidado
    },
     computed: {
        listagemMapaLeitos () {
            return this.$store.getters['leitos/getListagemMapaLeitos']
        },
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        },
    },
    methods: {
        consolidado() {
            this.$store.dispatch('consultas/buscaConsolidado', this.unidadeSelecionada.cnes)
        }
    }
}
</script>

<style>
    .botoes-excel {
        display: none;
    }

    .btn-excel {
        min-width: 125px;
    }

    @media (min-width: 1154px) {
        .botoes-excel {
            display: flex;
            flex-direction: column;
            justify-content: center;
            flex-wrap: wrap;
        }
    }
</style>